import { useEffect, useRef } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { toast } from "sonner"
import i18n from "@/lib/i18n/i18n"
import { getSharedRouteId, SHARED_ROUTE_PARAM } from "@/lib/appEntryLink"
import { loadRouteState, SavedRouteState } from "@/lib/routeStateUtils"

export function useSharedRouteLink(
  open: (route: SavedRouteState) => void,
  ready: boolean,
) {
  const routeId = getSharedRouteId(useLocation().search)
  const [, setSearchParams] = useSearchParams()
  const openedRouteIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!ready || !routeId || openedRouteIdRef.current === routeId) return
    openedRouteIdRef.current = routeId
    setSearchParams(
      (params) => {
        params.delete(SHARED_ROUTE_PARAM)
        return params
      },
      { replace: true },
    )

    loadRouteState(routeId).then((route) => {
      if (!route) {
        toast.error(i18n.t("planOrder.routeToasts.notFound"))
        window.analytics?.track("OrderOnPage_SharedRouteNotFound", { routeId })
        return
      }
      open(route)
      window.analytics?.track("OrderOnPage_SharedRouteLinkOpened", {
        routeId,
        stopsCount: route.temporaryRoute?.stops.length,
      })
    })
  }, [ready, routeId, setSearchParams, open])
}
